import { useNetworkScope } from './useNetworkScope'

// Where logging out should land you (TDC-1609).
//
// A brand client's front door is their own branded login,
// /portal/:brandSlug/login — not the generic TDC one. Every brand has that
// page now, not just rmn:true networks, because the API's public slug
// resolver was opened up to all brands.
//
// No role check: basePath is already '' for internal staff, experts and pros,
// so they keep /login. Inside a workspace, staff get that brand's login,
// which is also where their expired session would return them.
export function useLogoutPath(): string {
  const { basePath } = useNetworkScope()
  return basePath ? `${basePath}/login` : '/login'
}
